module.exports = __webpack_public_path__ + "static/img/HARLEY-BARKER.1acd2b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HARLEY-BARKER.jpg
// module id = bxh+
// module chunks = 0